import React, { type ReactNode, useLayoutEffect, useState } from "react";

import { darkTheme, lightTheme } from "../utils/themes";

export enum Theme {
  Light = "light",
  Dark = "dark",
}

const themes = {
  [Theme.Light]: lightTheme,
  [Theme.Dark]: darkTheme,
};

export type ThemeContext = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

export const ThemeContext = React.createContext<ThemeContext>({
  theme: Theme.Light,
} as ThemeContext);

/**
 * @
 * @param theme overrides the `setTheme` result
 * @returns
 */
export const ThemeProvider: React.FC<{ children: ReactNode; theme?: Theme }> = ({
  children,
  theme,
}) => {
  const [internalTheme, setInternalTheme] = useState(Theme.Light);

  const providedTheme = theme ?? internalTheme;

  useLayoutEffect(() => {
    const themeObject = themes[providedTheme];
    Object.entries(themeObject).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
  }, [providedTheme]);

  return (
    <ThemeContext.Provider value={{ theme: providedTheme, setTheme: setInternalTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
